import $ from "jquery";

$(".js-next-page").on("click", function (event) {
	event.preventDefault();

	$("html, body").animate({ scrollTop: 0 }, "smooth");
	$(".js-current-step").text("2");

	$(this)
		.closest(".steps-wrapper")
		.find(".step.current")
		.removeClass("current")
		.next(".step")
		.addClass("current")
		.end()
		.closest(".steps-wrapper")
		.find(".steps-nav li.current")
		.removeClass("current")
		.next("li")
		.addClass("current");
});

$(document).on("click", ".js-prev-page", function (event) {
	event.preventDefault();

	$(".js-current-step").text("1");

	$(this)
		.closest(".steps-wrapper")
		.find(".step.current")
		.removeClass("current")
		.prev(".step")
		.addClass("current")
		.end()
		.closest(".steps-wrapper")
		.find(".steps-nav li.current")
		.removeClass("current")
		.prev("li")
		.addClass("current");
});
